import React from 'react';
import { travels } from '../data/mock';

const Travel = () => {
  return (
    <div>
      <h1 className="text-2xl font-serif mb-3">Travel</h1>
      <p className="text-sm text-[#8f8fa3] mb-8">
        A running log of the trips and long walks I've taken over the past few years.
      </p>

      <div className="border-b border-[#1f1f23] mb-6"></div>

      <div className="space-y-0">
        {travels.map((trip) => (
          <div
            key={trip.id}
            className="py-4 border-b border-[#1f1f23] flex items-baseline justify-between"
          >
            <div>
              <span className="font-medium text-white">{trip.destination}</span>
              <span className="text-[#8f8fa3] ml-2">{trip.location}</span>
            </div>
            <div className="flex items-center gap-4 text-sm text-[#8f8fa3]">
              {trip.details && <span className="text-[#b2b2c3]">{trip.details}</span>}
              <span className="text-[#7a7a86]">{trip.year}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Travel;
